__turbopack_context__.v({
  "actions": "tweet-actions-module__TCXXfW__actions",
  "copy": "tweet-actions-module__TCXXfW__copy",
  "copyIcon": "tweet-actions-module__TCXXfW__copyIcon",
  "copyIconWrapper": "tweet-actions-module__TCXXfW__copyIconWrapper",
  "copyText": "tweet-actions-module__TCXXfW__copyText",
  "like": "tweet-actions-module__TCXXfW__like",
  "likeCount": "tweet-actions-module__TCXXfW__likeCount",
  "likeIcon": "tweet-actions-module__TCXXfW__likeIcon",
  "likeIconWrapper": "tweet-actions-module__TCXXfW__likeIconWrapper",
  "reply": "tweet-actions-module__TCXXfW__reply",
  "replyIcon": "tweet-actions-module__TCXXfW__replyIcon",
  "replyIconWrapper": "tweet-actions-module__TCXXfW__replyIconWrapper",
  "replyText": "tweet-actions-module__TCXXfW__replyText",
});
